/**
 * Transforms a media URL by applying the given processing options.
 *
 * @param contentServiceURL - The URL of the content service.
 * @param contentMediaID - The ID of the content media.
 * @param options - Optional parameters to customize the processing of the URL.
 *   - scale?: number - The scale factor to apply to the media (e.g., 0.5 or 2).
 * @returns The processed media URL with the applied options.
 */
export function transformContentMedia(contentServiceURL, contentMediaID, options = {}) {
    const link = new URL(`media/${contentMediaID}/download`, contentServiceURL);
    if (options.scale) {
        link.searchParams.set('scale', options.scale.toString());
    }
    return link.toString();
}
const SCALE_VARIANTS = [0.25, 0.5, 1, 1.5, 2];
/**
 * Generates a srcset attribute value for a media URL with different scale variants.
 *
 * @param contentServiceURL - The URL of the content service.
 * @param contentMediaID - The ID of the content media.
 * @param options - Optional parameters to customize the processing of the URL.
 * @returns A string representing the srcset attribute value.
 *
 * The function processes the given URL with the specified options and generates multiple URLs with different scales (0.25x to 2x) to be used in a srcset string.
 */
export function generateContentMediaSourceSet(contentServiceURL, contentMediaID, options = {}) {
    const scales = SCALE_VARIANTS.map(scale => {
        const setOptions = { ...options, scale };
        // Scale the width by the given factor.
        return transformContentMedia(contentServiceURL, contentMediaID, setOptions);
    });
    return scales.join(', ');
}
